import { render, staticRenderFns } from "./SPCompanyServices.vue?vue&type=template&id=65d9dca1&scoped=true"
import script from "./SPCompanyServices.vue?vue&type=script&lang=js"
export * from "./SPCompanyServices.vue?vue&type=script&lang=js"
import style0 from "./SPCompanyServices.vue?vue&type=style&index=0&id=65d9dca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9dca1",
  null
  
)

export default component.exports